import axios from "axios";
import { checkStatus, getHeaders } from "../SharedSevices/SharedServices";
import axiosInstance from "./UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;
const tokenKey = process.env.REACT_APP_API_BASE_KEY;

// For Master Data.
export const GetMasterData = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/GetMasterData`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//for uplaod document
export const uploadDoc = async (params, formData) => {
  const additionalHeaders = {};
  const headers = await getHeaders(additionalHeaders, ['authorization']);
  try {
    const response = await axiosInstance.post(`${baseURL}/Master/UploadFile?UploadType=${params?.UploadType}&RefId=${params?.RefId}`, formData, {
      headers: headers,
      body: formData
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For get the Leave Type.

export const GetMasterTypeData = async (param) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Master?masterType=${param.masterType}&allRecords=true&organisationId=${param.organisationId}`, {
      headers: await getHeaders(),
      body: JSON.stringify(param)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}



// For Get Sidebar Menu Dyanmic .
export async function menuDynamicFunctionality(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Functionality`,params,
      {        
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For get MasterSystemAlert After Login.

export const GetMasterSystemAlert = async (body) => {
  try {
    const response = await axios.get(`${baseURL}/Master/OrgSystemAlerts`, 
      {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const NotificationCount = async (params) => {
  try {
    const response = await axiosInstance.get(
      `${baseURL}/Employee/NotificationCount?EmpId=${params.EmpId}`,
       {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const GetMasterBeforeLoginSystemAlert = async (body) => {
  try {
    const response = await axios.get(
      `${baseURL}/Master/SystemAlerts?Name=${body.Name}`,
      {
        headers: {
          ...await getHeaders(),
          Authorization: `Bearer ${tokenKey}`,
        },
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// For Get Organization Holidays.
export async function orgSettings(params) {
  try {
    const response = await axiosInstance.post(`${baseURL}/Org/Settings`,params,
      {        
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}



// For Get Sidebar Menu Dyanmic .
export async function GetMasterType(params) {
  try {
    const response = await axiosInstance.get(`${baseURL}/Master/Language?allRecords=${params?.allRecords}&organisationId=${params?.organisationId}`,
      {        
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// for get FAQ
export async function GetFAQList(params) {
  try {
    const response = await axiosInstance.get(`${baseURL}/Master/FAQList?FAQTypeId=${params?.FAQTypeId}`,
      {        
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}






